import * as React from 'react';
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material';

const theme = createTheme({
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
});

export const MaterialThemeProvider: React.FC = ({ children }) => (
    <ThemeProvider theme={theme}>
        <StyledEngineProvider injectFirst>
            { children }
        </StyledEngineProvider>
    </ThemeProvider>
);
